import AiIcon from '@anonymizePro/components/icons/Ai-icon';
import Edit from '@anonymizePro/components/icons/edit';
import Metadata from '@anonymizePro/components/icons/metadata';
import Shield from '@anonymizePro/components/icons/shield';
import SearchIcon from '@anonymizePro/components/icons/search-icon';
import Finance from '@anonymizePro/components/icons/finance';
import Healthcare from '@anonymizePro/components/icons/healthcare';
import Legal from '@anonymizePro/components/icons/legal';
import Government from '@anonymizePro/components/icons/government';
import Tm7 from '@app/assets/images/anonymize-pro/tm7.png';
import Step1 from '@app/assets/images/anonymize-pro/features/step1.png';
import Step2 from '@app/assets/images/anonymize-pro/features/step3.png';
import Step3 from '@app/assets/images/anonymize-pro/features/step2.png';
import Step4 from '@app/assets/images/anonymize-pro/features/step4.png';

export const heroContent = {
    shortTitle: 'Stop wasting time redacting documents!',
    automate: 'Automate ',
    secureAnonymization: ' Secure Anonymization ',
    inSeconds: 'in Seconds',
    description: 'Our AI-powered platform anonymizes sensitive data in your documents, ensuring compliance and protecting your business.',
    buttonText: 'Schedule a free demo'
};
export const whatWeOfferContent = {
    title: 'What we offer',
    offers: [
        {
            icon: AiIcon,
            title: 'AI-powered anonymization',
            description: 'Automate redaction of sensitive data for complete control.'
        },
        {
            icon: Edit,
            title: 'Advanced redaction tools',
            description: 'Define custom rules for ultimate data protection flexibility.'
        },
        {
            icon: Metadata,
            title: 'Seamless metadata',
            description: 'Extract & embed data for post-anonymization analysis.'
        },
        {
            icon: Shield,
            title: 'Guaranteed GDPR,CCPA & HIPAA compliance',
            description: 'Anonymize with confidence, meet stringent regulations.'
        },
        {
            icon: SearchIcon,
            title: 'Automatic personal details detection',
            description: 'Minimize errors with auto-detection of names, addresses, social security numbers, and more.'
        }
    ]
};

export const testimonials = [
    {
        thoughts: '" Since implementing AnonymizePro, our document anonymization process is ten times faster and significantly more accurate. We can now focus on more important tasks while knowing our data is secure. "',
        author: 'Emily Chen',
        position: 'Data Protection Officer, Tech Innovations Ltd'
    }
];
export const pricing = {
    title: 'Simple Pricing for Secure Documents',
    description: 'Our document anonymizer software empowers you to confidently share sensitive information by providing a straightforward pricing structure.',
    types: [
        {
            title: 'Free Trial',
            isPopular: false,
            timeLimitation: '7 days',
            cost: 'Free',
            description: 'All feature Included. Try it before you buy it !',
            pageNumber: 5,
            additionalCost: 0,
            buttonText: 'Try for free'
        },
        {
            title: 'Essential',
            isPopular: false,
            timeLimitation: 'lifetime',
            cost: '9',
            description: 'Perfect for individuals or small businesses needing a basic document anonymization services.',
            pageNumber: 30,
            additionalCost: 0.27,
            buttonText: 'Get Started'
        },
        {
            title: 'Professional',
            isPopular: true,
            timeLimitation: 'lifetime',
            cost: '49',
            description: 'Perfect for professionals who handle sensitive data regularly and require robust document anonymization',
            pageNumber: 200,
            additionalCost: 0.21,
            buttonText: 'Get Started'
        },
        {
            title: 'Enterprise',
            isPopular: false,
            timeLimitation: 'lifetime',
            cost: '149',
            description: 'Perfect for large businesses or enterprises that need extensive document anonymization for data privacy compliance',
            pageNumber: 800,
            additionalCost: 0.17,
            buttonText: 'Get Started'
        }
    ]
};
export const useCasesContent = {
    title: 'Industry-specific Use cases',
    description: 'Our document anonymizer caters to a wide range of industries, offering secure data anonymization for all.',
    useCases: [
        {
            icon: Finance,
            title: 'Finance',
            description: 'Streamline secure audits and redact sensitive information (names, social security numbers, phone number) in financial statements for regulatory compliance.'
        },
        {
            icon: Healthcare,
            title: 'Healthcare',
            description: 'Collaborate securely with researchers on anonymized patient data (HIPAA compliant) to accelerate medical advancements. Publish anonymized reports that meet disclosure requirements.'
        },
        {
            icon: Legal,
            title: 'Legal',
            description: 'Redact sensitive details from legal documents before sharing with clients or third parties. Collaborate securely with external processors while maintaining attorney-client privilege.'
        },
        {
            icon: Government,
            title: 'Government',
            description: 'Share data securely between agencies and publish anonymized reports (e.g., stress tests) that meet disclosure requirements without compromising confidentiality.'
        }
    ]
};
export const trustedByContent = {
    title: 'Trusted by',
    clients: [
        {
            name: 'Tm7',
            logo: Tm7
        }
    ]
};
export const demonstrationContent = {
    title: 'Talk with our Expert',
    description: 'Please complete the form below. Our dedicated data privacy specialist will contact you shortly.',
    thankYouTitle: 'Thank you for your response!',
    thankYouPrimaryDescription: "I'm delighted to inform you that we have successfully received your message.",
    thankYouSecondaryDescription: 'Our team will be reaching out to you shortly to assist with AnonymizePro.'
};

export const featureContent = [
    {
        step: 1,
        title: 'Upload & Go',
        description: 'Submit your documents (office, PDF, scanned) - our system guides you through anonymization.',
        image: Step1
    },
    {
        step: 2,
        title: 'Refine & Collaborate',
        description: 'Review, adjust, and work together to achieve perfect anonymization. Our AI learns from your feedback.',
        image: Step2
    },
    {
        step: 3,
        title: 'Download Anonymized',
        description: 'Get your anonymized document, with formatting preserved and sensitive data removed.',
        image: Step3
    },
    {
        step: 4,
        title: 'Optional Re-identification',
        description: 'Need personal data back after processing? Easily restore it using the dashboard.',
        image: Step4
    }
];
